import { render, staticRenderFns } from "./UsersActivityTable.vue?vue&type=template&id=0f54e0d0&scoped=true&"
import script from "./UsersActivityTable.vue?vue&type=script&lang=js&"
export * from "./UsersActivityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54e0d0",
  null
  
)

export default component.exports